import type { FaireProductEntity } from "../../entity_types/product";

export const p_gtwb9gztja: FaireProductEntity = {
  token: "p_gtwb9gztja",
  type: "product",
  name: "Soul Chai Camp Cup (Case of 6)",
  brandToken: "b_wlog0i1yg7",
  brandName: "SØUL CHAI",
  imageUrl: "https://cdn.faire.com/fastly/43e6a35115fbe15d7c404aa27d1e0e033b6184996de9c86954d3c98e5770dd2d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/22fe5da2d2492abbeb0e8517ce5d0e87371d637eb8a124f3af1a4d1acf27fe22.jpeg",
    "https://cdn.faire.com/fastly/ab20abb638a98aea4ddcb8752886630f1188225a2c6c0d3eaa745d4616973114.jpeg",
    "https://cdn.faire.com/fastly/d5022b8d421457b472cce5993bf73823be209abe8523bb462b3ec6856567662c.jpeg",
    "https://cdn.faire.com/fastly/71c30bba38548b498e5924e359bef064fcbd2e1c2aed14750fc70769fc69dc44.jpeg"
  ],
  priceDollars: 105,
  description: "We’ve teamed up with MiiR to bring you a sleek & soulful take on the classic campfire mug!\n\nTake your chai ritual into the wild with this durable double-wall vacuum insulated cup for a flawless drinking experience. Crafted from premium 18/8 stainless steel, it’s lightweight yet keeps your beverages hot or cold for longer, making it an essential for the outdoors.\n\nThe press-fit slide lid design offers added insulation and a splash-proof seal so you can sip confidently. Comes in a 12oz size, great for drink versatility and daily use!\n\nComes by the case of 6x camp cups.",
  tags: [],
  msrpDollars: 210,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:58.400Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
